import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import UploadButton from '../../components/UploadButton';
import { FaFileDownload, FaUpload } from 'react-icons/fa';
import moment from 'moment';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoImportarInscricoes({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [arquivos, setArquivos] = useState([]);
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    let { state } = useLocation();
    var nomeEvento = state?.nomeEvento ?? null;
    const [dados, setDados] = useState({
        empresa: empresa,
        nomeEmpresa: nomeEmpresa
    });
    const history = useHistory();

    const buscar = (idParticipante) => {
        api({
            method: "get",
            action: '/eventoArquivo',
            token: token,
            params: {
                tipo: "inscricao",
                evento: id,
            }
        }).then(response => {
            var dadosRecebidos = response.data.data;
            setArquivos(dadosRecebidos);
        }).catch(err => {
            //console.log(err)
        });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Importar Inscrições</h1>
                        {nomeEvento && <p className="fin-pp__subtitle">{nomeEvento}</p>}
                    </div>
                    <div className="fin-pp__actions"></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <UploadButton
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"eventoImportarInscricoes"}
                        title="Selecionar Arquivo"
                        beforeSend={() => {
                            toast.info('Aguarde, isso pode levar alguns minutos');
                        }}
                        callBack={(data) => {
                            if (data.result === "sucesso") {
                                toast.success('Importação finalizada');
                                history.push("/eventoParticipante/" + id);
                            } else {
                                toast.error(data.message || data.error || "Erro desconhecido");
                            }
                        }}
                        dados={{
                            empresa: empresa,
                            evento: id
                        }}
                    >Selecionar Arquivo</UploadButton>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__cphead" style={{ padding: '12px 16px' }}>
                        <span className="fin-pp__cphead-title">Arquivos</span>
                    </div>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 80 }}>Arquivo</th>
                                    <th style={{ width: 200 }}>Data</th>
                                    <th>Operador</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arquivos.length === 0
                                    ? <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                    : arquivos.map((row, idx) => (
                                        <tr key={row.id || idx}>
                                            <td>
                                                {row.arquivo?.id ? (
                                                    <form method="get" action={process.env.REACT_APP_API_URL + "/eventoArquivo/" + row.id} target="_blank" style={{ display: 'inline' }}>
                                                        <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                        <button type="submit" className="fin-pp__btn fin-pp__btn--sm" title="Baixar arquivo">
                                                            <FaFileDownload size={16} />
                                                        </button>
                                                    </form>
                                                ) : null}
                                            </td>
                                            <td>{moment(row.created_at).format("DD/MM/YYYY HH:mm")}</td>
                                            <td>{row.operador?.nome ?? ""}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
